import React from "react";
import DemoButton from "../Demo/DemoButton";
import CustomButton from "../Buttons/CustomButton";
import Image from "next/image";
import slider1 from "@/Helper/images/slider/transportation/slider1.png";
import Link from "next/link";

const Transportation = () => {
  return (
    <div className="industry_container">
      <div className="industry_left_content">
        <p className="heading">
          Resolve smart city operations with AI technology
        </p>
        <p className="subheading">
          City wide traffic rules and vehicle movement processes can be
          optimized using AI video analytics. It offers strong surveillance
          throughout the city.
        </p>

        <div className="btn_container">
          <DemoButton PrimaryColorBtn />

          <Link href={"/smart-city"}>
            <CustomButton Text={"View More"}></CustomButton>
          </Link>
        </div>
      </div>
      <div className="industry_right_content">
        <div className="slider_bg normal_bg">
          <Image
            src={slider1}
            alt="Resolve smart city operations with AI technology"
            width={457}
            height={257}
            className="productbanner_imageslider"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
};

export default Transportation;
